module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Regular.woff2?98474e0bcf96a272fd61b62cbc7fda0d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Regular.woff2
// module id = 1418
// module chunks = 0